class ElementResizer {
    constructor() {
        this.body = document.getElementsByTagName('body')[0];
        this.elements = Array.from(document.querySelectorAll('.js-resize'));

        this.setAspectRatio();

        window.addEventListener('load', () => {
            this.resizeElements();
        });

        window.addEventListener('resize', () => {
            this.resizeElements();
        });
    }

    setAspectRatio() {
        this.elements.forEach((item) => {
            item.dataset.aspectRatio = (item.height / item.width); // eslint-disable-line no-param-reassign, max-len
            item.removeAttribute('width');
            item.removeAttribute('height');
        });
    }

    resizeElements() {
        this.elements.forEach((item) => {
            const fluidWidth = item.parentElement.scrollWidth;
            item.width = fluidWidth; // eslint-disable-line no-param-reassign
            item.height = (fluidWidth * item.dataset.aspectRatio); // eslint-disable-line no-param-reassign, max-len
        });
    }
}

export default ElementResizer;
